import { useInternalAnalytics } from 'utils/internalAnalytics'
import useTrackUIElementEvent from 'modules/analytics/hooks/useTrackUIElementEvent'
import mParticleSdk from '@mparticle/web-sdk'
import useConfig from 'modules/config/state/use-config'
import { getClassySessionId } from 'modules/utils/getClassySessionId'
import { getCookieValue } from 'modules/utils/getCookieValue'
import { useEffectOnceWhenReady } from './generalUtilHooks'
import { isReferrerFromWhammyDonatePage } from 'utils/functions/isReferrerFromWhammyDonatePage'

const useTrackMPartcleOnPageLoadEvents = (isReady: boolean) => {
  const trackEvent = useTrackUIElementEvent()
  const config = useConfig()
  const isRedirectedFromWhammy = isReferrerFromWhammyDonatePage()

  const { mParticle, consentSynced } = useInternalAnalytics()

  useEffectOnceWhenReady(() => {
    if (!mParticle || !consentSynced || !config) return

    // This event is being tracked on full page campaigns here rather than in whammy
    if (!config.isEmbedded && isRedirectedFromWhammy) {
      trackEvent('Donation Amount Submitted', mParticleSdk.EventType.Other, {})
    }

    mParticle.Identity.login({
      userIdentities: {
        other3: getCookieValue('pgdid') || getClassySessionId(),
      },
    })
  }, [isReady, isRedirectedFromWhammy, !!mParticle, !!consentSynced, !!config])
}

export default useTrackMPartcleOnPageLoadEvents
